import {
  REQUEST_ADMIN_ACCOUNT,
  REQUEST_ACCOUNT_LIST
} from './mutation-types';

export default {
  [REQUEST_ADMIN_ACCOUNT](state, receivedData) {
    state.adminAccount = receivedData;
  },

  [REQUEST_ACCOUNT_LIST](state, receivedData) {
    state.accountList = receivedData.content
    state.accountListCount = receivedData.totalElements
  },
}